import * as React from "react";
import { useGetPriorities } from "security-app/hooks/useInvestigationsAPI";
import { Spinner } from "components/common";
const PriorityValue = ({ priorityId }) => {
  const { priorities, loadingPriorities } = useGetPriorities();
  if (loadingPriorities) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const priority = priorities.find(({ id }) => priorityId === id);
  if (priority) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, priority.text);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, "unknown");
};
export default PriorityValue;
